export default __webpack_public_path__ + "static/media/Grid.a317085b.svg";